module.exports = __webpack_public_path__ + "static/media/DevOpsIcon.d06f8907.png";